import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { abnVariationQuery, abnVariationTranslationsUrl } from './paths';
import type { AbnVariationRef, AbnVariationTranslationsResponse } from './types';

/** Without `locale` the map is the variation's source map; with it, that locale's saved map. */
export async function getAbnVariationTranslations(ref: AbnVariationRef, locale?: string) {
  const params: Record<string, string> = abnVariationQuery(ref);
  if (locale) params.locale = locale;

  const response = await api.executeGetRequest<ObjectResponse<AbnVariationTranslationsResponse>>(
    abnVariationTranslationsUrl(ref),
    params
  );

  return response.data;
}
